import type { ResourceEndpoints } from '../core'

export const accountRelationshipsEndpoints = {
  collection: '/api/v1/account-relationships',
  item: (id: string) => `/api/v1/account-relationships/${encodeURIComponent(id)}`,
} satisfies ResourceEndpoints
